import { render } from "./ControlPanelInbox.vue?vue&type=template&id=36461643&scoped=true"
import script from "./ControlPanelInbox.vue?vue&type=script&lang=js"
export * from "./ControlPanelInbox.vue?vue&type=script&lang=js"

import "./ControlPanelInbox.vue?vue&type=style&index=0&id=36461643&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36461643"]])

export default __exports__